import React, { useState } from 'react';
import { Button, Input, Card } from '../common';

interface UrlInputFormProps {
  onSubmit: (url: string, title?: string) => Promise<void>;
  creditCost?: number;
  disabled?: boolean;
}

const URL_REGEX = /^https?:\/\/.+\..+/;

export default function UrlInputForm({
  onSubmit,
  creditCost = 1,
  disabled = false,
}: UrlInputFormProps) {
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateUrl = (value: string): string | null => {
    if (!value.trim()) {
      return 'URL is required';
    }
    if (!URL_REGEX.test(value)) {
      return 'Enter a valid URL (e.g. https://example.com/article).';
    }
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationError = validateUrl(url);
    if (validationError) {
      setError(validationError);
      return;
    }

    setError(null);
    setLoading(true);

    try {
      await onSubmit(url);
      setUrl('');
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'Failed to add source';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <Input
            label="Source URL"
            type="url"
            placeholder="https://example.com/article"
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              if (error) setError(null);
            }}
            error={error || undefined}
            disabled={disabled || loading}
            required
          />
        </div>

        <div className="flex items-center justify-between pt-2">
          <p className="font-mono text-xs tracking-wide uppercase text-muted-foreground">
            Uses <span className="text-foreground">{creditCost} credit</span>
          </p>

          <Button type="submit" loading={loading} disabled={disabled}>
            Convert to audio
          </Button>
        </div>
      </form>
    </Card>
  );
}
